import '../../base/style/css.mjs';
import 'element-plus/theme-chalk/el-badge.css';
//# sourceMappingURL=css.mjs.map
